import type { Address } from '@/shared';

export type SalespointAddressFields = {
  address: Address | null;
  address_text: string | null;
  address_country: string | null;
  address_postcode: string | null;
  address_region: string | null;
  address_city: string | null;
  address_street: string | null;
  address_house: string | null;
  address_flat: string | null;
};

type AddressPart = {
  type_short?: string;
  name?: string;
};

function formatAddressPart(part?: AddressPart | null): string | null {
  if (!part?.name?.trim()) return null;

  const name = part.name.trim();
  const typeShort = part.type_short?.trim();

  return typeShort ? `${typeShort} ${name}` : name;
}

function toAddressText(value: string | Address | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string') return value.trim();

  return value.address_text?.trim() || '';
}

export function addressToSalespointFields(
  value: string | Address | null | undefined,
  fallback?: Partial<SalespointAddressFields> | null
): SalespointAddressFields {
  const addressText = toAddressText(value);

  if (value && typeof value === 'object') {
    const address = value as Address;

    return {
      address,
      address_text: address.address_text?.trim() || addressText || null,
      address_country: 'Россия',
      address_postcode: address.postal_code?.trim() || null,
      address_region: formatAddressPart(address.region),
      address_city: formatAddressPart(address.city),
      address_street: formatAddressPart(address.street),
      address_house: address.house?.trim() || null,
      address_flat: address.flat?.trim() || null
    };
  }

  if (fallback) {
    return {
      address: fallback.address ?? null,
      address_text: addressText || fallback.address_text || null,
      address_country: fallback.address_country ?? null,
      address_postcode: fallback.address_postcode ?? null,
      address_region: fallback.address_region ?? null,
      address_city: fallback.address_city ?? null,
      address_street: fallback.address_street ?? null,
      address_house: fallback.address_house ?? null,
      address_flat: fallback.address_flat ?? null
    };
  }

  return {
    address: null,
    address_text: addressText || null,
    address_country: null,
    address_postcode: null,
    address_region: null,
    address_city: null,
    address_street: null,
    address_house: null,
    address_flat: null
  };
}
